import { methods } from './addToCalendarModal.constants';
import { transformCalendarEventDate } from '@bloobirds-it/utils';

const formatCalendarDate = (dateTime, method = methods.METHOD_GOOGLE) => {
  const isMethodGoogle = method === methods.METHOD_GOOGLE;
  const {
    year,
    monthStr: month,
    hourStr: hour,
    minStr: min,
    dayStr: day,
  } = transformCalendarEventDate(dateTime, isMethodGoogle);
  return isMethodGoogle
    ? `${year}${month}${day}T${hour}${min}00Z`
    : `${year}-${month}-${day}T${hour}:${min}:00`;
};

export const buildCalendarLink = (
  { title, fromDate, toDate, guests },
  method = methods.METHOD_GOOGLE,
) => {
  const fromString = formatCalendarDate(fromDate, method);
  const toString = formatCalendarDate(toDate, method);
  const encodedTitle = encodeURI(title);
  const guestList = Array.isArray(guests) && guests.length > 0 ? guests.join(',') : null;
  let params;

  const baseUrl =
    method === methods.METHOD_GOOGLE
      ? 'https://calendar.google.com/calendar/render'
      : 'https://outlook.office.com/calendar/deeplink/compose';

  if (method === methods.METHOD_GOOGLE) {
    params = `action=TEMPLATE&text=${encodedTitle}&dates=${fromString}/${toString}`;

    if (guestList) {
      params = `${params}&add=${guestList}`;
    }
  } else {
    params = `subject=${encodedTitle}&startdt=${fromString}&enddt=${toString}`;

    if (guestList) {
      params = `${params}&to=${guestList}`;
    }
  }

  return `${baseUrl}?${params}`;
};
